import React from "react";

import { useTranslation } from "react-i18next";
import BaseActionButton from "./BaseActionButton";

const DeleteButton = ({
    hide,
    onClick,
    disabled,
    className,
    tippy,
    tippySettings,
}) => {
    const { t } = useTranslation();

    return (
        <BaseActionButton
            className={`table-btn table-btn-orange ${className || ""}`}
            hide={hide}
            onClick={onClick}
            disabled={disabled}
            icon={"fas fa-trash-alt"}
            tippySettings={
                tippy
                    ? {
                          content: t("delete"),
                      }
                    : tippySettings
            }
        />
    );
};

export default DeleteButton;
